export default "__VITE_ASSET__Bz3tGDhF__"